import React from "react";
import ListDetails from "../components/list/ListDetails";

const ListPage = () => {
  return (
    <div className="page">
      <ListDetails />
    </div>
  );
};

export default ListPage;
